module.exports = __webpack_public_path__ + "static/media/help_Individual.96946fde.png";